module.exports = __webpack_public_path__ + "assets/img/introduction_honour_bg.165c727e.png";